import IMask from 'imask'
import { on } from 'delegated-events'
import { handleValidation, handleBlur } from '../common/validation'

const $form = document.querySelector('form.multistepform')
const $simpleForm = document.querySelector('form')

const state = {
    skipValidation: false,
}

const fn = {
    init: () => {
        on('blur', '.has-error', handleBlur, { capture: true })
        on('change', '.has-error', handleBlur, { capture: true })
        on('change', '.has-error blur', handleBlur, {
            capture: true,
        })

        on('change', 'input[type=radio]', fn.handleToggle)
        on('change', 'input[type=checkbox]', fn.handleToggle)

        on('click', '[formnovalidate]', () => {
            state.skipValidation = true
        })
        on('submit', '[data-form-validate]', fn.handleValidation)

        // Manage Group handlers
        on('click', '.manage-group-add-action', fn.handleAddManageGroupBlock)
        on(
            'click',
            '.manage-group-remove-action',
            fn.handleRemoveManageGroupBlock
        )
        on(
            'blur',
            '[data-manage-group-target]',
            fn.handleUpdateManageGroupBlock,
            {
                capture: true,
            }
        )

        fn.showToggles()
        fn.setupSpecialFields()
        fn.setupManageGroups()
    },

    showToggles: () => {
        if (!$form) {
            return
        }

        $form.querySelectorAll(`[data-toggle-if]`).forEach(($input) => {
            const $targetEl = $form.querySelector(
                `[name="${$input.dataset.toggleIf.split('|')[0]}"]:checked`
            )
            const targetValue = $input.dataset.toggleIf.split('|')[1]
            const $toggleGroup = $input.closest('.toggle-group')

            if ($targetEl && $targetEl.value === targetValue) {
                $toggleGroup.classList.remove('hidden')
            }
        })
    },

    handleToggle: (e) => {
        const field = e.target
        const name = e.target.name
        const selectedValue = e.target.value

        if (!$form) {
            return
        }

        $form
            .querySelectorAll(`[data-toggle-if^="${name}|"]`)
            .forEach(($input) => {
                const $toggleGroup = $input.closest('.toggle-group')
                let shouldShow = false

                if (field.type === 'radio') {
                    const targetValue = $input.dataset.toggleIf.split('|')[1]
                    shouldShow = targetValue === selectedValue
                }

                if (field.type === 'checkbox') {
                    shouldShow = field.checked
                }

                if (shouldShow) {
                    $toggleGroup.classList.remove('hidden')
                } else {
                    $toggleGroup.classList.add('hidden')

                    $toggleGroup
                        .querySelectorAll('input')
                        .forEach((x) => (x.value = null))
                }
            })
    },

    handleValidation: (e) => {
        if (state.skipValidation) {
            return true
        }

        const valid = handleValidation(e.target)

        if (!valid) {
            e.preventDefault()
        }

        return valid
    },

    setupSpecialFields: () => {
        document.querySelectorAll('form').forEach(($form) => {
            // Setup file inputs
            $form.querySelectorAll('input[type=file]').forEach(($input) => {
                const $placeholder = document.createElement('div')
                $placeholder.classList.add('file-input-placeholder')

                if ($input.value) {
                    $placeholder.textContent = $input.files[0].name
                } else {
                    $placeholder.textContent = $input.dataset.placeholder
                }

                $input.parentNode.insertBefore($placeholder, $input)

                $placeholder.addEventListener('click', () => $input.click())

                $input.addEventListener('change', (e) => {
                    let files = e.target.files
                    if (files.length > 1) {
                        $placeholder.textContent = `${files.length} files selected`
                    } else {
                        $placeholder.textContent = e.target.files[0].name
                    }
                    $placeholder.classList.add('filled')
                })
            })

            $form.querySelectorAll('input.ssn.masked').forEach(($input) => {
                IMask($input, {
                    lazy: false,
                    mask: '000-00-0000',
                })
            })

            $form.querySelectorAll(`input[type="tel"]`).forEach(($input) => {
                IMask($input, {
                    mask: '(000) 000-0000',
                })
            })

            $form.querySelectorAll('input.phone-number').forEach(($input) => {
                IMask($input, {
                    mask: '(000) 000-0000',
                })
            })
        })
    },

    setupManageGroups: () => {
        if (!$form) {
            return
        }

        const $groups = $form.querySelectorAll('.manage-group')

        $groups.forEach(($group) => {
            const $targets = $group.querySelectorAll(
                '[data-manage-group-target]'
            )

            $targets.forEach(($field) => {
                if ($field && $field.value) {
                    const $block = $field.closest('.manage-group-block')
                    const blockIndex = $block.dataset.index
                    const isInitial = parseInt(blockIndex) === 1

                    if (isInitial) {
                        return
                    }

                    $block.classList.remove('hidden')
                    fn.addBlockToList($group, $field.value, blockIndex)
                }
            })
        })
    },

    handleAddManageGroupBlock: (e) => {
        const $button = e.target.closest('button')
        const $group = $button.closest('.manage-group')
        const $nextBlock = $group.querySelectorAll('.manage-group-block.hidden')

        if ($nextBlock.length) {
            $nextBlock[0].classList.remove('hidden')

            fn.addBlockToList(
                $group,
                $button.dataset.pendingLabel,
                $nextBlock[0].dataset.index
            )
        }

        fn.toggleAddAction($group)
    },

    toggleAddAction: ($group) => {
        const $button = $group.querySelector('.manage-group-add-action')

        const visibleBlocks = $group.querySelectorAll(
            '.manage-group-block:not(.hidden)'
        ).length

        if (visibleBlocks >= $group.dataset.limit) {
            $button.classList.add('hidden')
        } else {
            $button.classList.remove('hidden')
        }
    },

    addBlockToList: ($group, label, index) => {
        const $list = $group.querySelector('.manage-group-list')

        const $listItem = document.createRange().createContextualFragment(`
      <li class="flex items-center justify-between py-2">
        <div data-label-index="${index}">${label}</div>
        <button type="button" class="text-gray-dark text-xl manage-group-remove-action" data-index="${index}">&times;</button>
      </li>
    `)

        $list.appendChild($listItem)
    },

    handleRemoveManageGroupBlock: (e) => {
        const $button = e.target.closest('button')
        const $listItem = $button.closest('li')
        const $group = $button.closest('.manage-group')
        const $block = $group.querySelector(
            `.manage-group-block[data-index="${$button.dataset.index}"]`
        )

        $block.querySelectorAll('input, select').forEach(($input) => {
            $input.value = null
        })

        $block.classList.add('hidden')
        $listItem.remove()

        fn.toggleAddAction($group)
    },

    handleUpdateManageGroupBlock: (e) => {
        const $input = e.target
        const $group = $input.closest('.manage-group')
        const $block = $input.closest('.manage-group-block')
        const blockIndex = $block.dataset.index
        const $listItemLabel = $group.querySelector(
            `.manage-group-list [data-label-index="${blockIndex}"]`
        )

        if ($input.value && $listItemLabel) {
            $listItemLabel.textContent = $input.value
        }
    },
}

export default {
    can: () => $form || $simpleForm,
    run: fn.init,
}
